<h2 mat-dialog-title>Verificação de integridade concluída</h2>

<mat-dialog-content>
  <div fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="row" fxLayoutGap="24px">
      <div><strong>Total verificado:</strong> {{ data.totalVerificado }}</div>
      <div class="text-success"><mat-icon inline>check_circle</mat-icon> {{ data.integros }} íntegros</div>
      <div *ngIf="data.reenviados > 0" class="text-warning"><mat-icon inline>sync</mat-icon> {{ data.reenviados }} reenviados</div>
      <div *ngIf="data.falhas > 0" class="text-danger"><mat-icon inline>error</mat-icon> {{ data.falhas }} falhas</div>
    </div>

    <div *ngIf="reenviados.length > 0">
      <h3>Documentos reenviados</h3>
      <table class="result-table">
        <thead>
          <tr>
            <th>Documento</th>
            <th>Número anterior</th>
            <th>Novo número</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of reenviados">
            <td>{{ item.nome }}</td>
            <td>{{ item.numeroAnterior }}</td>
            <td>{{ item.numeroNovo }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="falhas.length > 0">
      <h3>Falhas</h3>
      <table class="result-table">
        <thead>
          <tr>
            <th>Documento</th>
            <th>Erro</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of falhas">
            <td>{{ item.nome }}</td>
            <td class="text-danger">{{ item.erro }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="reenviados.length === 0 && falhas.length === 0">
      <p>Todos os documentos estão íntegros no SIGAD. Nenhuma ação necessária.</p>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
